/**
 * Task PM: shop-defined payment methods (收款方式) — settings card, till buttons, report labels.
 * One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts + en/zh/ms.ts.
 */
const ROWS = [
  ["pm.title","Payment methods","收款方式"],
  ["pm.intro","Choose which ways of paying appear at the till and in which order. Add your own, e.g. {examples}.","选择收银台显示哪些收款方式及其顺序。可添加店铺自己的方式，例如{examples}。"],
  ["pm.builtin","Built-in","内置"],
  ["pm.yours","Your methods","自定义收款方式"],
  ["pm.none","No methods of your own yet.","还没有自定义收款方式。"],
  ["pm.add","Add method","添加收款方式"],
  ["pm.edit","Edit method","编辑收款方式"],
  ["pm.name","Name (English)","名称（英文）"],
  ["pm.nameZh","Chinese name (optional)","中文名称（选填）"],
  ["pm.icon","Icon","图标"],
  ["pm.color","Colour","颜色"],
  ["pm.requiresRef","Requires reference no.","需要参考编号"],
  ["pm.requiresRefHint","Staff must enter the transaction / approval number when taking this payment.","收款时店员必须填写交易号 / 授权号。"],
  ["pm.cashLike","Counts as cash in drawer","计入钱箱现金"],
  ["pm.cashLikeHint","On: the amount is added to the expected cash at cash-up (日结). Leave off for e-wallets and QR payments.","开启后，金额会计入日结时钱箱的应有现金。电子钱包和二维码付款请保持关闭。"],
  ["pm.branches","Available at","适用门店"],
  ["pm.allBranches","All branches","全部门店"],
  ["pm.hidden","Hidden","已隐藏"],
  ["pm.show","Show at till","在收银台显示"],
  ["pm.hide","Hide","隐藏"],
  ["pm.archive","Archive","归档"],
  ["pm.archived","Archived","已归档"],
  ["pm.restore","Restore","恢复"],
  ["pm.remove","Remove","移除"],
  ["pm.removeConfirm","Remove {name}? If it was already used it is archived instead — past sales and reports keep its name.","移除「{name}」？如已被使用，将改为归档——过往销售和报表仍保留其名称。"],
  ["pm.up","Move up","上移"],
  ["pm.down","Move down","下移"],
  ["pm.used","{n} payments","{n} 笔收款"],
  ["pm.stripeOnly","Shown when Stripe is connected","连接 Stripe 后显示"],
  ["pm.cashLikeTag","Counts as cash","计入现金"],
  ["pm.refTag","Ref. no.","需参考号"],
  ["pm.ref","Reference no.","参考编号"],
  ["pm.manual","Recorded manually","手动记录"],
  ["pm.archivedNote","Archived methods are hidden at the till; past sales and reports keep their name.","已归档的方式不会在收银台显示；过往销售和报表仍保留其名称。"],
  ["pm.readOnly","Only the owner or a manager can change payment methods.","只有店主或经理可以修改收款方式。"],
  ["pm.saved","Saved","已保存"],
  ["pm.otherMethods","Other methods","其他方式"],
  ["pm.sameMethod","Refund to the same method","退回原收款方式"],
  ["apiError.payment_method_unavailable","This payment method is switched off or not available at this branch.","此收款方式已关闭或不适用于本门店。"],
  ["apiError.payment_method_required","Choose which payment method.","请选择收款方式。"],
  ["apiError.payment_method_limit","You can have at most 30 payment methods.","最多可添加 30 种收款方式。"],
  ["apiError.payment_method_builtin","Built-in methods can be hidden but not deleted.","内置收款方式只能隐藏，不能删除。"],
] as const;

export type PmKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<PmKey, string>;

export const taskPM = { en: col(1), zh: col(2), ms: col(1) };
